import React from 'react';

const customSelect = ({ input, label, type, className, disabled, meta: { touched, error }, children }) => (
  <div className={'form-group'}>
    { label && <label>{label}</label>}
    <select {...input} type={type} disabled={disabled} className={(touched && error) ? 'form-control is-invalid' : 'form-control'}>
      {children}
    </select>
    {touched && error && <span className="invalid-feedback">{error}</span>}
  </div>
)

export default customSelect;


// WEBPACK FOOTER //
// ./src/components/Select/index.js